<template>
	<div class="container_box">
		<div class="content pt-15">
			<!-- 内容 -->
			<div class="bold9 size20 color1 mb-20">
				项目名称：{{ jingJiaDetail.title }}
			</div>
			<div class="flex between">
				<!-- 竞价信息 -->
				<div>
					<div class="box">
						<div v-if="jjStatus == 2" class="zhunbei">
							<div class="zhunbeizhong">竞价准备中</div>
							<!-- <div class="time">{{ yingJiaTime | dateFormat }}</div> -->
							<count-down :time="zhunBeiTime" @change="timeChange1" @success="endTime1"></count-down>
						</div>
						<div v-if="jjStatus == 3" class="zhunbei">
							<div class="zhunbeizhong">正常竞价中</div>
							<div class="time"></div>
						</div>
						<div v-if="jjStatus == 4" class="zhunbei">
							<div class="zhunbeizhong">加速竞价中</div>
							<div class="time"></div>
						</div>
						<div v-if="jjStatus == 5" class="zhunbei">
							<div class="zhunbeizhong">竞价已结束</div>
							<div class="time"></div>
						</div>

						<div class="center-border"></div>

						<div class="xmxx">
							<span style="
                  font-size: 14px;
                  color: #3b426b;
                  font-weight: bold;
                  margin-bottom: 8px;
                ">项目信息</span>
							<div class="textBox flex flex-column around" style="padding-right: 5px">
								<span>场次号：{{ jingJiaDetail.sessionNum }}</span>
								<span>报价方式：{{
                    guiZeObj.quotationMode == 1 ? "连续报价" : ""
                  }}</span>
								<span>竞价开始时间：{{ jingJiaDetail.beginTime }}</span>
								<span>本次竞价时间：{{ time | mf }}</span>
							</div>
						</div>
						<div class="center-border"></div>
						<div class="bjgz">
							<span style="
                  font-size: 14px;
                  color: #3b426b;
                  font-weight: bold;
                  margin-bottom: 8px;
                ">连续报价规则</span>
							<div class="textBox flex flex-column around">
								<span>准备时间：{{ guiZeObj.prepareTime }}秒</span>
								<span>应价时间：{{ guiZeObj.biddingTime }}秒</span>
								<span>加速应价时间：{{ guiZeObj.quickBiddingTime }}秒</span>
							</div>
						</div>
						<div class="center-border"></div>

						<div class="dlxx">
							<span style="
                  font-size: 14px;
                  color: #3b426b;
                  font-weight: bold;
                  margin-bottom: 8px;
                ">连续报价规则</span>
							<div class="textBox flex flex-column around">
								<span>公司名称：{{ supplierName }}</span>
								<span>报价号码：{{ jingJiaDetail.bidderNum }}
									<span v-if="jingJiaDetail.bidderNum">号报价人</span></span>
							</div>
						</div>
					</div>
				</div>

				<!-- 竞价须知 -->
				<div class="listBox flex flex-column between" v-if="isDetails">
					<div>
						<div style="
                font-size: 20px;
                font-weight: bold;
                color: #3b426b;
                margin-bottom: 10px;
              ">
							竞价须知
						</div>
						<div class="ql-editor" v-html="guiZeObj.biddingNotice"></div>
					</div>
					<div class="flex flex-center">
						<div class="btn pointer" @click="goJingGaiKaiShi">接受</div>
						<div class="btn no-btn pointer ml-20" @click="goIndex">不接受</div>
					</div>
				</div>
				<div v-else>
					<!-- 竞价须知 -->
					<div class="Box">
						<!-- 表格 -->
						<div class="tableBox">
							<div style="
                  font-size: 14px;
                  font-weight: bold;
                  color: #3b426b;
                  margin-bottom: 14px;
                ">
								报价记录
							</div>
							<div v-for="(val, key, index) in jiLuObj" :key="index" class="mt-20"
								style="height: 160px; overflow-y: auto; overflow-x: hidden">
								<hd-scroll>
									<!-- 表格 -->
									<el-table :header-cell-style="{
                      background: '#3B426C',
                      color: '#ffffff',
                      padding: '0px',
                      height: '40px',
                    }" :cell-style="{ padding: '0px' }" :row-style="{ height: '40px' }" class="mb-10" :data="val"
										stripe style="
                      font-size: 14px;
                      border-radius: 20px 20px 0 0;
                      border: 1px solid #3b426b;
                    ">
										<el-table-column type="index" label="序号" align="center" width="100px">
											<template></template>
										</el-table-column>
										<el-table-column prop="subTitle" label="分包" align="center">
										</el-table-column>
										<el-table-column prop="bidderNum" label="报价人" align="center">
											<template slot-scope="scope">
												{{ scope.row.bidderNum }}号报价人
											</template>
										</el-table-column>
										<el-table-column prop="bidAmount" label="报价金额" align="center">
											<template slot-scope="scope">
												<div v-format="'#,###.##'">
													{{ scope.row.bidAmount }}
												</div>
											</template>
										</el-table-column>
										<el-table-column prop="bidTime" label="报价时间" align="center">
										</el-table-column>
									</el-table>
								</hd-scroll>
							</div>
						</div>
						<!-- 分包 -->
						<div v-if="isFenBaoShow" class="flex between items-center">
							<div class="fenbaoBox" v-for="(item, i) in jingJiaDetail.subDetailList" :key="i">
								<div :class="item.isDialog ? 'fenbaoBox-active' : ''">
									<!-- <div
                    v-if="item.isEnd"
                    class="topTextEnd flex flex-cenetr items-center"
                  >
                    <div class="leftTextEnd items-center flex flex-center">
                      {{ item.subTitle }}
                    </div>
                  </div> -->
									<div class="topText flex between">
										<div class="leftText">{{ item.subTitle }}</div>
										<div class="rightText flex flex-column around">
											<div>最高限价:<span v-format="'#,###.##'">{{
                          item.initialBidding
                        }}</span>元</div>
											<div>每次报价不低于:<span v-format="'#,###.##'">{{
                          item.eachQuote
                        }}</span>元</div>
											<div>每次报价不高于:<span v-format="'#,###.##'">{{
							item.eachMaxQuote
						}}</span>元</div>

											<span @click="closeSearch(item, i)">产品明细：{{
                          item.isStatus == false ? "展开" : "收起"
                        }}
												<i :class="
                            item.isStatus
                              ? 'iconfont icon-shangjiantou_huaban'
                              : 'iconfont icon-xiajiantou_huaban'
                          "></i>
												<!-- 表格 -->
												<el-table v-if="item.isStatus" :header-cell-style="{
                            background: '#3B426C',
                            color: '#ffffff',
                            padding: '0px',
                            height: '40px',
                          }" :cell-style="{ padding: '0px' }" :row-style="{ height: '40px' }" id="tableBox"
													class="dialog mb-10" :data="item.productList" stripe>
													<el-table-column prop="productName" label="产品名称" align="center">
													</el-table-column>
													<el-table-column prop="productSpec" label="产品型号" align="center">
													</el-table-column>
													<el-table-column prop="purchaseNum" label="采购数量" align="center">
													</el-table-column>
												</el-table>
											</span>
										</div>
									</div>

									<div class="bottomBox flex flex-column around items-center">
										
										<div>当前最低价:<span v-format="'#,###.##'">{{
                        item.bidAmount 
                      }}</span>元</div>
										<span>最低报价人:{{ item.bidderNum }}
											<span v-if="item.bidderNum">号报价人</span></span>
										<div class="flex items-center" style="font-weight: bold" v-if="!item.isEnd">
											应价时间：
											<count-down class="text" :time="item.biddingTime"
												@change="timeChange($event, item, i)" @success="endTimeSuc(item, i)">
											</count-down>
										</div>
										<div v-if="!item.isEnd">
											<el-input style="width: 120px; margin: o auto" v-model="priceArr[i]"
												placeholder="请输入金额" oninput="value=value.replace(/[^\d.]/g,'')">
											</el-input>
											<div class="btn" @click="baoJia(item, i)">报价</div>
										</div>
										<div class="bottomBoxEnd flex flex-center items-center" v-else>
											已结束
										</div>
									</div>
								</div>

								<!-- 价格弹窗 -->
								<div v-if="item.isDialog" class="price-box flex flex-center items-center">
									<!-- 									<div v-if="item.isWuBao" class="dialog-box">
										<div class="title" style="color: red">
											降价幅度过大请确认金额
										</div>
										<div class="mt-15 money size14 bold">
											{{ priceArr[i] }}元
										</div>
										<div class="btn-box flex around mt-15 pl-15 pr-15">
											<div class="pointer yes size14 bold" @click="moneyYes(item, i)">
												确定
											</div>
											<div @click="moneyNo(item, i)" class="pointer yes no-yes size14 bold">
												取消
											</div>
										</div>
									</div> -->
									<div class="dialog-box">
										<div class="title">请确认报价金额</div>
										<div class="mt-15 money size14 bold">
											<span v-format="'#,###.##'">{{ priceArr[i] }}</span>元
										</div>
										<div class="btn-box flex around mt-15 pl-15 pr-15">
											<div class="pointer yes size14 bold" @click="moneyYes(item, i)">
												确定
											</div>
											<div @click="moneyNo(item, i)" class="pointer yes no-yes size14 bold">
												取消
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-if="jingJiaDetail.subDetailList.length == 2" class="fenbaoBox" style="opacity: 0">
							</div>
						</div>
						<div v-else class="zhengbao">
							<div class="title size14">产品明细</div>
							<div class="flex between">
								<div class="leftTable">
									<!-- 表格 -->
									<el-table :header-cell-style="{
                      background: '#3B426C',
                      color: '#ffffff',
                      padding: '0px',
                      height: '40px',
                    }" :cell-style="{ padding: '0px' }" :row-style="{ height: '40px' }" id="tableBox" class="mb-10"
										:data="jingJiaDetail.subDetailList[0].productList" stripe>
										<el-table-column prop="productName" label="产品名称" align="center">
										</el-table-column>
										<el-table-column prop="productSpec" label="产品型号" align="center">
										</el-table-column>
										<el-table-column prop="purchaseNum" label="采购数量" align="center">
										</el-table-column>
									</el-table>
								</div>
								<div v-for="(item, i) in jingJiaDetail.subDetailList" :key="i"
									class="rightInfo size14 flex flex-column items-center">
									<div class="max">
										最高限价:<span v-format="'#,###.##'">{{ item.initialBidding }}</span>元
									</div>
									<div class="min mt-10">
										每次报价不低于:<span v-format="'#,###.##'">{{ item.eachQuote }}</span>元
									</div>
									<div class="min mt-10">
										每次报价不高于:<span v-format="'#,###.##'">{{ item.eachMaxQuote }}</span>元
									</div>
									<div class="current mt-20">
										当前最低价:<span v-format="'#,###.##'">{{ item.bidAmount }}</span>元
									</div>
									<div class="name mt-10">
										最低报价人:{{ item.bidderNum }}
										<span v-if="item.bidderNum">号报价人</span>
									</div>
									<div class="date mt-10 bold" v-if="!item.isEnd">
										应价时间：
										<!-- <span class="text"
                      >{{ item.biddingTime | dateFormat }}
                    </span> -->
										<count-down class="text" :time="item.biddingTime"
											@change="timeChange($event, item, i)" @success="endTimeSuc(item, i)">
										</count-down>
									</div>
									<div v-if="!item.isEnd" class="mt-20 mb-15">
										<el-input placeholder="请输入金额" v-model="priceArr[i]"
											oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
									</div>
									<div v-if="!item.isEnd" class="btn mt-15 bold pointer" @click="baoJia(item, i)">
										报价
									</div>
									<div v-if="item.isEnd" class="flex flex-center items-center bottomBoxEndZb">
										已结束
									</div>
									<!-- 价格弹窗 -->
									<div v-if="item.isDialog" class="price-box flex flex-center items-center">
										<!-- 										<div v-if="item.isWuBao" class="dialog-box">
											<div class="title" style="color: red">
												降价幅度过大请确认金额
											</div>
											<div class="mt-15 money size14 bold">
												{{ priceArr[i] }}元
											</div>
											<div class="btn-box flex around mt-15 pl-15 pr-15">
												<div class="pointer yes size14 bold" @click="moneyYes(item, i)">
													确定
												</div>
												<div @click="moneyNo(item, i)" class="pointer yes no-yes size14 bold">
													取消
												</div>
											</div>
										</div> -->
										<div class="dialog-box">
											<div class="title">请确认报价金额</div>
											<div class="mt-15 money size14 bold">
												<span v-format="'#,###.##'">{{ priceArr[i] }}</span>元
											</div>
											<div class="btn-box flex around mt-15 pl-15 pr-15">
												<div class="pointer yes size14 bold" @click="moneyYes(item, i)">
													确定
												</div>
												<div @click="moneyNo(item, i)" class="pointer yes no-yes size14 bold">
													取消
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Result :title="resultTitle" :SubTitle="subTitle" :isShow="resultShow" @change="resultClose" />
	</div>
</template>

<script>
	import CountDown from "../components/CountDow.vue";
	import hdScroll from "../components/scroll.vue";
	import Result from "../components/Result.vue";
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';

	export default {
		components: {
			CountDown,
			hdScroll,
			Result
		},
		data() {
			return {
				minPrice: 0,
				isFenBaoShow: true,
				isDetails: true,
				supplierName: window.sessionStorage.getItem("supplierName"),
				baoJiaItem: {},
				total: 0,
				bid: null,
				guiZeObj: {},
				jingJiaDetail: {},
				//是否展开
				showAll: false,

				//报价记录列表
				jiLuObj: {},
				jiLuList0: [],
				jiLuList1: [],
				jiLuList2: [],
				price: "",
				time: "", //本次竞价时间
				socket: null, //socket
				isBaoJia: false, //报价按钮是否可以点击
				zhengBaoTime: null,
				isDialog: false, //整包的弹窗是否显示
				index: 0, //分包的下标
				jjStatus: "",
				yingJiaTime: "", //固定的应价时间
				zhunBeiTime: 0,
				resultTitle: "",
				subTitle: "",
				resultShow: false,
				timeOut: "",
				priceArr: [],
			};
		},
		created() {
			this.bid = window.sessionStorage.getItem("jjId");
		},
		mounted() {
			this.getGuiZe();
			this.getJingJiaDetail();
			//初始化socket
			this.socketInit();
			document.addEventListener("visibilitychange", this.handleWindowChange);
		},

		methods: {
			//浏览器窗口隐藏显示变换
			handleWindowChange(e) {
				switch (e.target.visibilityState) {
					case "prerender":
						break;
					case "hidden":
						break;
					case "visible":
						if (this.jjStatus == 2) {
							this.statusIsZhunBei();
						} else {
							this.getJingJiaDaoJiShi();
						}
						break;
				}
			},
			resultClose() {
				this.resultShow = false;
			},
			//倒计时发生变化时
			timeChange(val, item, i) {
				item.biddingTime = val;
				this.jingJiaDetail.subDetailList.splice(i, 1, item);
			},
			timeChange1(val) {
				this.zhunBeiTime = val;
			},

			//倒计时结束时
			endTimeSuc(item, i) {
				item.isEnd = true;
				this.jingJiaDetail.subDetailList.splice(i, 1, item);
				// this.getJingJiaDetail();
			},
			endTime1() {
				// this.jjStatus = 3;
				this.getJingJiaDetail();
			},
			//点击不接受返回首页
			goIndex() {
				this.$router.push("/index");
			},

			//WebSockte初始化
			socketInit() {
				if (typeof WebSocket === "undefined") {
					this.resultTitle = "socket链接失败";
					this.subTitle1 = "您的浏览器不支持socket,请升级浏览器";
					this.resultShow = true;
					return;
				} else {
					// 实例化socket
					this.socket = new WebSocket(
						this.$static.SERVER_WS + "/websocket/message"
					);
					// 监听socket连接
					this.socket.onopen = this.open;
					// 监听socket错误信息
					this.socket.onerror = this.error;
				}
			},
			//获取socket信息
			getMessage(msg) {
				if (msg.data != "连接成功") {
					let jiLuObj = JSON.parse(msg.data);
					//判断是否是当前竞价
					if (jiLuObj.biddingId == this.bid) {
						//如果竞价开始
						if (jiLuObj.biddingStatus && jiLuObj.biddingStatus == 3) {
							this.jjStatus = 3;
						}
						//判断是否本次竞价结束
						if (jiLuObj.biddingEnd && jiLuObj.biddingEnd == 1) {
							this.jjStatus = 5;
							this.resultTitle = "竞价已结束";
							this.subTitle = "请至成交公告查看详情";
							this.resultShow = true;
							this.jingJiaDetail.subDetailList.some((item, i) => {
								item.isEnd = true;
								this.jingJiaDetail.subDetailList.splice(i, 1, item);
							});

							// this.timeOut = setTimeout(() => {
							//   if (this.$route.path == "/jjxz") {
							//     this.$router.push("/");
							//   }
							// }, 1000 * 60 * 10);
						}
						//判断是否需要进入加速竞价
						if (jiLuObj.biddingAcc && jiLuObj.biddingAcc == 1) {
							this.jjStatus = 4;
							this.getJingJiaDaoJiShi();
						}
						this.jingJiaDetail.subDetailList.some((item) => {
							if (jiLuObj.subId == item.id) {
								if (jiLuObj.bidAmount && jiLuObj.bidderNum) {
									// this.jiLuList.splice(0, 0, jiLuObj);
									for (var key in this.jiLuObj) {
										if (jiLuObj.subId == key) {
											this.jiLuObj[key].splice(0, 0, jiLuObj);
										}
									}
									item.bidAmount = jiLuObj.bidAmount;
									item.bidderNum = jiLuObj.bidderNum;
									// this.priceArr[i] = null;

									this.getJingJiaDaoJiShi();

									// this.jingJiaDetail.subDetailList.splice(i, 1, item);
								}

								// if (this.jjStatus == 3) {
								//   item.biddingTime = this.guiZeObj.biddingTime;
								// }
								// if (this.jjStatus == 4) {
								//   item.biddingTime = this.guiZeObj.quickBiddingTime;
								// }
								// //判断是否本次分包竞价是否结束
								// if (jiLuObj.subEnd && jiLuObj.subEnd == 1) {
								//   // this.$message.error("分包" + item.subTitle + "竞价结束");
								//   // this.resultTitle = "竞价已结束";
								//   // this.subTitle = `分包 ${item.subTitle} 竞价结束`;
								//   // this.resultShow = true;
								//   item.biddingTime = 0;
								//   item.isEnd = true;
								// }
							}
						});
					}
				}
			},
			// 打开socket链接
			open() {
				// 监听socket消息
				this.socket.onmessage = this.getMessage;
			},
			//socket错误
			error() {
				this.resultTitle = "socket链接失败";
				this.subTitle1 = "";
				this.resultShow = true;
				return;
			},
			close() {
				console.log("socket已经关闭");
			},

			//获取竞价详情
			async getJingJiaDetail() {
				const {
					data: res
				} = await this.$axios.get(
					`/api/biddingInfo/getBiddingDetail`, {
						params: {
							biddingId: this.bid,
							userId: window.sessionStorage.getItem("userId"),
						},
					}
				);
				if (res.code == 200) {
					this.jjStatus = res.data.status;
					if (res.data.status == 2) {
						this.statusIsZhunBei();
					}
					if (res.data.status == 5) {
						this.resultTitle = "竞价已结束";
						this.subTitle = "请至成交公告查看详情";
						this.resultShow = true;
					}
					this.time =
						(new Date(res.data.endTime) - new Date(res.data.beginTime)) / 1000;
					// if(this.time.indexOf(".")){}subTitle
					for (var i = 0; i < res.data.subDetailList.length; i++) {
						res.data.subDetailList[i].price = null;
						if (res.data.subDetailList[i].subTitle.length > 5) {
							res.data.subDetailList[i].subTitle =
								res.data.subDetailList[i].subTitle.substr(0, 5) + "...";
						}
						res.data.subDetailList[i].isStatus = false;
						res.data.subDetailList[i].bidAmount = res.data.subDetailList[i]
							.lowQuotePrice ?
							res.data.subDetailList[i].lowQuotePrice :
							res.data.subDetailList[i].initialBidding;
						res.data.subDetailList[i].bidderNum =
							res.data.subDetailList[i].lowQuoteSupplier;
						res.data.subDetailList[i].isDialog = false;
						res.data.subDetailList[i].isEnd =
							res.data.subDetailList[i].endFlag == 1 ? true : false;
						res.data.subDetailList[i].isWuBao = false;
						res.data.subDetailList[i].biddingTime = 0;
					}
					this.jingJiaDetail = res.data;
				} else {
					console.log(res);
				}
			},
			//获取报价记录
			// async getBaoJiaJiLu() {
			//   const { data: res } = await this.$axios.get(
			//     "/api/biddingInfo/getQuoteRecord",
			//     {
			//       params: {
			//         biddingId: this.bid,
			//         // supplierId: window.sessionStorage.getItem("supplierId"),
			//         supplierId: "",
			//       },
			//       headers: {
			//         token: window.sessionStorage.getItem("token"),
			//       },
			//     }
			//   );
			//   if (res.code == 200) {
			//     this.jiLuList = res.data;
			//   } else {
			//     this.$message.closeAll();
			//     return this.$message.error(res.msg);
			//   }
			// },
			async getBaoJiaJiLu() {
				const {
					data: res
				} = await this.$axios.get(
					"/api/biddingInfo/getQuoteRecForSubArray", {
						params: {
							biddingId: this.bid,
							// supplierId: window.sessionStorage.getItem("supplierId"),
							// supplierId: "",
						},
						headers: {
							token: window.sessionStorage.getItem("token"),
						},
					}
				);
				if (res.code == 200) {
					this.jiLuObj = res.data;
				} else {
					console.log(res.msg);
				}
			},
			closeSearch(item, i) {
				item.isStatus = !item.isStatus;
				this.jingJiaDetail.subDetailList.splice(i, 1, item);
			},
			//点击报价
			baoJia(item, i) {
				if (item.biddingTime == 0) {
					this.resultTitle = "竞价已结束";
					this.subTitle = "请至成交公告查看详情";
					this.resultShow = true;
					return;
				}
				// this.priceArr[i] = Number(this.priceArr[i]);
				if (this.priceArr[i] == "" || this.priceArr[i] == null) {
					this.resultTitle = "请输入价格";
					this.subTitle = "";
					this.resultShow = true;
					return;
				}
				if (this.priceArr[i] > item.initialBidding) {
					this.resultTitle = "报价不得高于最高限价";
					this.subTitle = "";
					this.resultShow = true;
					return;
				}
				if (this.priceArr[i] > item.bidAmount) {
					this.resultTitle = "每次报价不得高于当前最低价";
					this.subTitle = "";
					this.resultShow = true;
					return;
				}
				if (this.priceArr[i] > item.bidAmount - item.eachQuote) {
					this.resultTitle =
						"本次报价不得高于" + (item.bidAmount - item.eachQuote) + "元";
					this.subTitle = "";
					this.resultShow = true;
					return;
				}
				//2022-05-09 新增每次出价降价幅度不能高于每次最高限价
				if (this.priceArr[i] < item.bidAmount - item.eachMaxQuote) {
					this.resultTitle =
						"本次报价不得低于" + (item.bidAmount - item.eachMaxQuote) + "元";
					this.subTitle = "";
					this.resultShow = true;
					return;
				}

				item.isDialog = !item.isDialog;
				this.baoJiaItem = item;
				this.index = i;
				// this.jingJiaDetail.subDetailList.splice(i, 1, item);
			},
			//报价确定按钮
			async moneyYes(item, i) {
				// this.baoJiaItem = item;
				// this.index = i;
				// if (item.bidAmount - this.priceArr[i] >= item.eachQuote * 5) {
				// 	// item.isWuBao = true;
				// 	this.$confirm("此次价格降幅过大, 是否继续?", "提示", {
				// 			confirmButtonText: "确定",
				// 			cancelButtonText: "取消",
				// 			type: "warning",
				// 		})
				// 		.then(async () => {
				// 			if (!this.priceArr[i]) return;
				// 			const {
				// 				data: res
				// 			} = await this.$axios({
				// 				url: "/api/biddingInfo/submitQuote",
				// 				method: "post",
				// 				headers: {
				// 					token: window.sessionStorage.getItem("token"),
				// 				},
				// 				data: {
				// 					biddingId: item.biddingId,
				// 					subId: item.id,
				// 					userId: window.sessionStorage.getItem("userId"),
				// 					supplierId: window.sessionStorage.getItem("supplierId"),
				// 					bidderNum: this.jingJiaDetail.bidderNum,
				// 					bidAmount: this.priceArr[i],
				// 					subTitle: item.subTitle,
				// 				},
				// 			});
				// 			if (res.code == 200) {
				// 				item.isDialog = !item.isDialog;
				// 				this.priceArr[i] = null;
				// 				this.resultTitle = "报价成功";
				// 				this.subTitle = res.msg;
				// 				this.resultShow = true;
				// 				// this.jingJiaDetail.subDetailList.splice(i, 1, item);
				// 			} else {
				// 				// this.$message.closeAll();
				// 				// return this.$message.error(res.msg);
				// 				item.isDialog = !item.isDialog;
				// 				this.priceArr[i] = null;

				// 				this.resultTitle = "报价失败";
				// 				this.subTitle = res.msg;
				// 				this.resultShow = true;
				// 			}
				// 		})
				// 		.catch(() => {
				// 			item.isDialog = !item.isDialog;
				// 			this.priceArr[i] = null;
				// 			return;
				// 		});
				// } else {
				const {
					data: res
				} = await this.$axios({
					url: "/api/biddingInfo/submitQuote",
					method: "post",
					headers: {
						token: window.sessionStorage.getItem("token"),
					},
					data: {
						biddingId: item.biddingId,
						subId: item.id,
						userId: window.sessionStorage.getItem("userId"),
						supplierId: window.sessionStorage.getItem("supplierId"),
						bidderNum: this.jingJiaDetail.bidderNum,
						bidAmount: this.priceArr[i],
						subTitle: item.subTitle,
					},
				});
				if (res.code == 200) {
					item.isDialog = !item.isDialog;
					this.priceArr[i] = null;
					this.resultTitle = "报价成功";
					this.subTitle = res.msg;
					this.resultShow = true;
					// this.jingJiaDetail.subDetailList.splice(i, 1, item);
				} else {
					// this.$message.closeAll();
					// return this.$message.error(res.msg);
					item.isDialog = !item.isDialog;
					this.priceArr[i] = null;

					this.resultTitle = "报价失败";
					this.subTitle = res.msg;
					this.resultShow = true;
				}
				// }

				// item.price = null;
			},
			moneyNo(item, i) {
				this.priceArr[i] = null;
				item.isDialog = !item.isDialog;
				this.jingJiaDetail.subDetailList.splice(i, 1, item);
			},
			//获取竞价规则
			async getGuiZe() {
				const {
					data: res
				} = await this.$axios.get(
					"/api/biddingInfo/getBiddingRule", {
						params: {
							biddingId: this.bid,
						},
						headers: {
							token: window.sessionStorage.getItem("token"),
						},
					}
				);
				if (res.code == 200) {
					this.guiZeObj = res.data;
				} else {
					console.log(res);
				}
			},
			// 点击我接受的时候
			goJingGaiKaiShi() {
				if (this.jjStatus == 5) {
					// this.$message.closeAll();
					// return this.$message.info("竞价已结束");
					this.resultTitle = "竞价已结束";
					this.subTitle = "请至成交公告查看详情";
					this.resultShow = true;
					return;
				} else if (this.jjStatus != 3 && this.jjStatus != 4) {
					this.resultTitle = "竞价还未开始";
					this.subTitle = "竞价还未开始,请稍后在试";
					this.resultShow = true;
					return;
				} else if (this.jjStatus == 3 || this.jjStatus == 4) {
					this.getJingJiaDaoJiShi();
				} // else if (this.jjStatus == 4) {
				//   // this.jingJiaDetail.subDetailList.some((item, i) => {
				//   //   item.biddingTime = this.guiZeObj.quickBiddingTime;
				//   //   this.jingJiaDetail.subDetailList.splice(i, 1, item);
				//   // });
				// }
				this.getBaoJiaJiLu();

				if (this.jingJiaDetail.subDetailList.length > 1) {
					this.isFenBaoShow = true;
				} else {
					this.isFenBaoShow = false;
				}
				this.isDetails = false;
			},

			//竞价状态为准备中时请求倒计时
			async statusIsZhunBei() {
				const {
					data: res
				} = await this.$axios({
					url: "/api/biddingInfo/getPrepareCountdown",
					params: {
						biddingId: this.bid,
					},
					headers: {
						token: window.sessionStorage.getItem("token"),
					},
				});
				if (res.code == 200) {
					this.zhunBeiTime = Number(res.data);
				} else {
					console.log(res);
				}
			},
			//开始请求竞价倒计时
			async getJingJiaDaoJiShi() {
				const {
					data: res
				} = await this.$axios.get(
					"/api/biddingInfo/getBiddingCountdown", {
						params: {
							biddingId: this.bid,
						},
						headers: {
							token: window.sessionStorage.getItem("token"),
						},
					}
				);
				// console.log(res.data);
				if (res.code == 200) {
					for (var key in res.data) {
						this.jingJiaDetail.subDetailList.some((item, i) => {
							if (key == item.id) {
								item.biddingTime = res.data[key];
								this.jingJiaDetail.subDetailList.splice(i, 1, item);
							}
						});
					}
				} else if (res.code == 508) {
					this.jingJiaDetail.subDetailList.some((item, i) => {
						item.isEnd = true;
						this.jingJiaDetail.subDetailList.splice(i, 1, item);
					});
				}
			},
		},
		destroyed() {
			this.socket.onclose = this.close();
			clearTimeout(this.timeOut);
			document.removeEventListener("visibilitychange", this.handleWindowChange);
		},
	};
</script>

<style scoped lang="less">
	.bottomBoxEnd {
		min-height: 100px;
		max-height: 200px;
		box-sizing: border-box;
		font-size: 30px;
		color: #ccd9e9;
		font-weight: bold;
	}

	.bottomBoxEndZb {
		height: 200px;
		box-sizing: border-box;
		font-size: 30px;
		color: #ccd9e9;
		font-weight: bold;
	}

	.content_box {
		background: url("../assets/imgs/bg.png") no-repeat;
		padding-bottom: 43px;
	}

	.content {
		width: 1200px;
		margin: auto;
	}

	.listBox {
		width: 855px;
		height: 803px;
		background-color: #fff;
		padding: 32px 40px;
		box-sizing: border-box;
	}

	.btn {
		// margin-top: 15px;
		width: 80px;
		height: 30px;
		border-radius: 25px;
		background-color: #1c65c4;
		line-height: 30px;
		text-align: center;
		color: #fff;
		// margin: 0 auto;
		margin-bottom: 20px;
	}

	.no-btn {
		background-color: #cccc;
		color: #444;
	}

	.Box {
		margin-left: 26px;

		//右侧表格
		.tableBox {
			padding: 20px 20px;
			box-sizing: border-box;
			width: 872px;
			// height: 364px;
			// height: 600px;
			border-right: 4px solid #95b3db;
			background-color: #fff;
			margin-bottom: 27px;
		}

		.fenbaoBox-active {
			filter: blur(2px);
		}

		.fenbaoBox {
			position: relative;
			width: 280px;
			height: 411px;
			border-radius: 20px;
			background-color: #fff;
			box-sizing: border-box;
			padding: 35px 10px;

			.price-box {
				width: 280px;
				height: 411px;
				position: absolute;
				top: 0;
				left: 0;
				background: rgba(28, 101, 196, 0.05);
				border-radius: 20px;
				box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.6);
				filter: none;

				.dialog-box {
					width: 180px;
					height: 130px;
					background: #fff;

					.title {
						text-align: center;
						height: 38px;
						line-height: 38px;
						color: #1c65c4;
						font-size: 14px;
						font-weight: bold;
						border-bottom: 1px solid #ccd9e9;
					}

					.money {
						color: #3b426b;
						text-align: center;
					}

					.btn-box {
						.yes {
							width: 60px;
							height: 30px;
							background: #1c65c4;
							text-align: center;
							line-height: 30px;
							color: #fff;
							border-radius: 25px;
							box-sizing: border-box;
						}

						.no-yes {
							background: #ccd9e9;
						}
					}
				}
			}

			.topTextEnd {
				border-bottom: 1px solid #ccd9e9;
				box-sizing: border-box;
				padding-bottom: 24px;

				.leftTextEnd {
					width: 100%;
					height: 77px;
					box-sizing: border-box;
					// padding-right: 5px;
					// border-right: 1px solid #1c65c4;
					font-size: 18px;
					text-align: center;
					// line-height: 77px;
					display: flex;
					flex-direction: column;
					justify-content: center;

					color: #1c65c4;
					// margin-right: 5px;
					font-weight: bold;
				}
			}

			.topText {
				border-bottom: 1px solid #ccd9e9;
				box-sizing: border-box;
				padding-bottom: 24px;

				.leftText {
					text-align: center;
					min-width: 90px;
					height: 77px;
					box-sizing: border-box;
					padding-right: 5px;
					border-right: 1px solid #1c65c4;
					font-size: 18px;
					// line-height: 77px;
					display: flex;
					flex-direction: column;
					justify-content: center;
					color: #1c65c4;
					margin-right: 5px;
					font-weight: bold;
				}

				.rightText {
					span {
						color: #3b426b;
						font-size: 14px;

						.iconfont {
							color: #1c65c4;
							font-size: 16px !important;
						}

						#tableBox {
							width: 258px;
							height: 274px;
							font-size: 14px;
							border-radius: 10px;
							border: 1px solid #1c65c4;
							position: absolute;
							top: 120px;
							left: 11px;
							// display: none;
							z-index: 1 !important;
						}
					}
				}
			}

			.bottomBox {
				height: 274px;
				box-sizing: border-box;
				padding: 29px 0px;
				text-align: center;

				span {
					color: #3b426b;
					font-size: 14px;
				}

				.text {
					color: #ff0053;
					font-size: 24px;
				}

				.btn {
					margin-top: 15px !important;

					width: 80px;
					height: 30px;
					margin: 0 auto;
					text-align: center;
					line-height: 30px;
					background-color: #1c65c4;
					color: #fff;
					border-radius: 25px;
					cursor: pointer;
				}
			}
		}
	}

	//整包内容
	.zhengbao {
		padding-left: 20px;

		.title {
			color: #3b426b;
			margin-bottom: 11px;
		}

		.leftTable {
			width: 556px;
			border-right: 1px solid #1c65c4;

			#tableBox {
				width: 510px;

				font-size: 14px;
				border-radius: 10px;
				border: 1px solid #1c65c4;
			}
		}

		.rightInfo {
			width: 280px;
			color: #3b426b;
			position: relative;
			height: 350px;

			.price-box {
				width: 280px;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 100;
				background: rgba(28, 101, 196, 0.05);
				border-radius: 20px;
				box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.6);
				filter: none;

				.dialog-box {
					width: 180px;
					height: 130px;
					background: #fff;

					.title {
						text-align: center;
						height: 38px;
						line-height: 38px;
						color: #1c65c4;
						font-size: 14px;
						font-weight: bold;
						border-bottom: 1px solid #ccd9e9;
					}

					.money {
						color: #3b426b;
						text-align: center;
					}

					.btn-box {
						.yes {
							width: 60px;
							height: 30px;
							background: #1c65c4;
							text-align: center;
							line-height: 30px;
							color: #fff;
							border-radius: 25px;
							box-sizing: border-box;
						}

						.no-yes {
							background: #ccd9e9;
						}
					}
				}
			}

			.date {
				.text {
					color: #ff0053;
					font-size: 36px;
				}
			}

			.btn {
				color: #fff;
				width: 80px;
				height: 30px;
				text-align: center;
				line-height: 30px;
				background: #1c65c4;
				border-radius: 25px;
			}
		}
	}

	.box {
		width: 298px;
		height: 100%;
		background-color: #fff;
		padding: 20px;
		box-sizing: border-box;
		margin-bottom: 25px;

		.zhunbei {
			padding-top: 60px;
			padding-left: 24px;
			margin-bottom: 50px;

			.zhunbeizhong {
				font-size: 20px;
				color: #1c65c4;
				font-weight: bold;
				margin-bottom: 5px;
			}

			.time {
				font-size: 40px;
				color: #ff0053;
			}
		}

		.xmxx,
		.bjgz,
		.dlxx {
			padding-left: 24px;
		}
	}

	.loginBox {
		width: 294px;
		height: 259px;
		background-color: #fff;
		padding: 35px 22px 44px 20px;
		box-sizing: border-box;
	}

	.textBox {
		width: 252px;
		border-radius: 13px;
		//   border: 1px solid #95b3db;
		margin-top: 8px;
		margin-bottom: 30px;
		box-sizing: border-box;
		color: #565c7f;
		font-size: 14px;
	}

	.textBox-border {
		border: 1px solid #95b3db;
	}

	.center-border {
		width: 252px;
		border: 1px solid #95b3db;
		height: 0;
		margin-bottom: 40px;
	}
</style>
